export default __webpack_public_path__ + "static/match-1acb369aafb765769bbb0f532ad68cff.png";